module.exports = __webpack_public_path__ + "img/bg-blur-1-dark.9706bf95.svg";